import { NavLink } from 'react-router-dom'

import { cn } from '@/lib/cn'
import { Compass, Package, Plus } from '@/lib/icons'

const ITEM =
  'flex min-h-11 min-w-11 flex-col items-center gap-1 rounded-md px-3'
const LABEL = 'font-body text-[10px] font-semibold tracking-wide uppercase'

export function MobileTabBar() {
  return (
    <nav
      aria-label="Mobile"
      className="border-glass-border bg-surface/90 fixed inset-x-0 bottom-0 z-50 h-20 border-t pb-[env(safe-area-inset-bottom)] backdrop-blur-lg md:hidden"
    >
      <ul className="flex h-full items-center justify-around">
        <li>
          <NavLink
            to="/discover"
            className={({ isActive }) =>
              cn(ITEM, isActive ? 'text-primary' : 'text-fg-muted')
            }
          >
            <Compass className="size-6" aria-hidden="true" />
            <span className={LABEL}>Browse</span>
          </NavLink>
        </li>

        <li>
          <NavLink
            to="/drop"
            className={({ isActive }) =>
              cn(
                ITEM,
                isActive ? 'text-primary' : 'text-fg-muted hover:text-primary',
              )
            }
          >
            <span className="bg-primary-gradient shadow-glow-strong -mt-6 rounded-full p-3 text-white">
              <Plus className="size-6" aria-hidden="true" />
            </span>
            <span className={LABEL}>Post</span>
          </NavLink>
        </li>

        <li>
          <NavLink
            to="/stash"
            className={({ isActive }) =>
              cn(
                ITEM,
                isActive ? 'text-primary' : 'text-fg-muted hover:text-primary',
              )
            }
          >
            <Package className="size-6" aria-hidden="true" />
            <span className={LABEL}>Stash</span>
          </NavLink>
        </li>
      </ul>
    </nav>
  )
}
